<template>
    <div>
        <snoop-html-content tag="h2" class="snoop-modal__title" :html="translations.headline" />
        <snoop-html-content
            tag="p"
            class="snoop-modal__introduction"
            :html="translations.intro"
        />

        <snoop-html-content
            v-if="optionalMessage"
            tag="p"
            class="snoop-modal-alert qa-modal-alert"
            :html="optionalMessage"
        />
        <div class="snoop-footer__buttons row">
            <div class="col-12 col-md-6">
                <div class="snoop-footer__link-buttons">
                    <snoop-button
                        class="qa-cookie-consent-settings"
                        theme="link"
                        @click="$emit('showSettings')"
                    >{{ translations.settings }}</snoop-button>
                    <snoop-button
                        class="qa-cookie-consent-accept-required"
                        theme="link"
                        @click="$emit('acceptTechnicallyRequired')"
                    >{{ translations.acceptTechnicallyRequired }}</snoop-button>
                </div>
            </div>
            <div class="col-12 col-md-6 snoop-footer__accept-all">
                <snoop-button
                    class="qa-cookie-consent-accept-all"
                    theme="primary"
                    @click="$emit('acceptAll')"
                >{{ translations.acceptAll }}</snoop-button>
            </div>
        </div>
    </div>
</template>

<script>
import SnoopButton from './Button.vue'
import SnoopHtmlContent from './HtmlContent.vue'


export default {
    components: { SnoopButton, SnoopHtmlContent },

    props: {
        translations: { type: Object, required: true },
        optionalMessage: { type: String, required: true },
    },
}
</script>
